import * as React from "react";
import SettingsDashboardForm from './SettingsDashboardForm';
import Container from '@mui/material/Container';
import { Box } from "@mui/material";

const SettingsDashboard = (props) => { 

  return (
    <div className="App" style={{backgroundColor:'#FAFAFA', }}>
      <Box sx={{bgcolor:'#FAFAFA', width: "100%", maxWidth: "100%"}}>
        <SettingsDashboardForm 
            refreshkey={props.refreshKey} 
        />
      </Box>

    </div>
  );
}
export default SettingsDashboard;
